import template from '../../../static/js/template'
import compileVariableUtil from '../../../static/js/compileVariableUtil'
import validateConverterUtil from '../../dynamicFrom/libs/validateConverterUtil'
import calculateUtil from '../../../static/js/calculateUtil'
import { filter } from '../../filter/index'
import dynamicItemUtil from '../../dynamicFrom/libs/dynamicItemUtil'
import objectUtil from '../../../static/js/objectUtil'
const getValue = objectUtil.getValueByPath

function validateConverterhandle(item, rowData) {
  var fCreateApi = {}
  fCreateApi.getFormData = function () {
    return rowData
  }
  //动态表单标题名title
  item.title = item.label
  let validators
  if (item.validators) {
    validators = JSON.parse(JSON.stringify(item.validators))
  } else {
    validators = item.validators
  }
  var validates = validateConverterUtil.converterValidates(validators, item, fCreateApi)
  return validates
}

export default {
  name: 'cellRender',
  props: {
    column: Object,
    store: {
      type: Object,
      default: null,
    },
    // 扩展对象属性会出现在，绑定模板变量的 extend 中
    extendData: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, Object],
      default: null,
    },
    //启用校验时候，指定校验的key
    rowDataKey: {
      type: String,
    },
    validateTable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dataIndex() {
      const key = this.rowDataKey || 'items'
      if (this.extendData?.formData?.[key]) {
        return this.extendData.formData[key].findIndex((item) => item._ID === this.value._ID)
      }
      return -1
    },
  },
  render(h) {
    //如果有特俗显示逻辑
    const parameter = this.column.parameter
    let type = null,
      format = null,
      symbol = null
    if (parameter) {
      type = parameter.type ? parameter.type : null
      format = parameter.format || parameter.format === 0 ? parameter.format : null
      symbol = parameter.symbol || parameter.symbol === 0 ? parameter.symbol : null
    }
    if (parameter && parameter.clearParent && this.value.children) {
      //父行字段是否不展示值
      return h('span', {}, '-')
    }
    if (parameter && parameter.clearChildren && this.value._PARENT) {
      //子行字段是否不展示值
      return h('span', {}, '-')
    }
    if (parameter && parameter.totalChildren && this.value.children) {
      //父行字段是否展示为子行该字段的合计
      let total = this.value.children.reduce(
        (pre, cur) =>
          calculateUtil.numberAdd(pre, objectUtil.getValueByPath(cur, this.column.property)),
        0
      )
      return h('span', {}, filter(total, type, format, symbol))
    }
    //渲染组件
    const componentCode = dynamicItemUtil.convertComponentName(
      this.column.component?.code || 'readText'
    )
    let initValue = getValue(this.value, this.column.property, 'hasOwnProperty')
    if (initValue === 'hasOwnProperty') {
      initValue = null
      objectUtil.setValueByPathForVue(this.value, this.column.property, initValue, this)
    }
    const propsCompileData = compileVariableUtil.getCompileVariable(
      this.value,
      this,
      this.extendData
    )
    propsCompileData.parentData = getValue(this.extendData, 'formData')
    const propsCompile = template.render(parameter, propsCompileData)
    //当为input组件时支持设置maxlength
    if (this.column.length > 0 && ~['input', 'i-input', 'Input'].indexOf(componentCode)) {
      propsCompile.maxlength = propsCompile.maxlength ?? this.column.length
    }
    if (this.column.disabled) {
      propsCompile.disabled = this.column.disabled
    }
    //渲染单元格数据
    const vNodeParam = {
      on: {
        input: (val) => {
          objectUtil.setValueByPathForVue(this.value, this.column.property, val, this)
          const cBorthers = parameter.changeBorthers
          if (cBorthers) {
            let temp = {}
            Object.keys(cBorthers).forEach((im) => {
              let otherFields = cBorthers[im]
              if (!otherFields) {
                temp[im] = otherFields
              } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
                temp[im] = template.render(otherFields, propsCompileData)
              } else {
                temp[im] = getValue(val, otherFields)
              }
            })
            console.log('******sideSelect***this.changeBorthersObj***********', temp)
            Object.keys(temp).forEach((im) => {
              objectUtil.setValueByPathForVue(this.value, im, temp[im], this)
            })
          }
          this.$emit('on-change', { val: val })
        },
      },
      style: template.render(this.column.style, propsCompileData),
    }
    //如果是component-plus库中的组件，将属性都渲染在attrs中
    if (componentCode.indexOf('Pg') > -1) {
      vNodeParam.attrs = {
        disabled: this.disabled,
        value: initValue,
        store: this.store,
        ...propsCompile,
      }
    } else {
      vNodeParam.props = {
        disabled: this.disabled,
        value: initValue,
        store: this.store,
        ...propsCompile,
      }
    }
    const vNode = h(componentCode, vNodeParam)
    //判断是否包装校验
    if (this.column.required && this.dataIndex !== -1) {
      const key = this.rowDataKey || 'items'
      const propStr = key + '[' + this.dataIndex + '].' + this.column.property
      if (this.store && this.validateTable) {
        this.store.commit('setTableValidate', this.column)
      }
      const propsData = {
        key: this.column.property + this.dataIndex,
        prop: propStr,
        labelWidth: 0.1,
        rules: validateConverterhandle(this.column, this.value),
      }
      return h(
        'form-item',
        {
          props: propsData,
          class: {
            'pg-form-item-minWidth':
              this.column.required || (this.column.validators && this.column.validators.length > 0),
          },
          style: {
            marginBottom: '0px',
            padding: '0',
          },
        },
        vNode
      )
    }
    return vNode
  },
}
